import { error } from '@sveltejs/kit';
import { getGuide, getGuides } from '$lib/guides';

export const prerender = true;

export function entries() {
	return getGuides().map((guide) => ({ slug: guide.slug }));
}

export function load({ params }) {
	if (!params.slug) {
		throw error(404, 'Guide not found');
	}

	return {
		guide: getGuide(params.slug)
	};
}
